<template>
    <div class="basicData" v-wechat-title="$t('设备类型维护')">
        <Title :title="$t('设备类型维护')"/>
        <div class="common_title add_account">{{ $t('设备分类') }}</div>
        <div class="content">
          <div class="left">
            <div class="tree_opt">
              <div v-show="breadList.length">
                <button type="button" class="normal_gray_btn ise-mr10" @click="uploadFile.file = '';importDialog = true" v-show="level === 0" v-permissions="26030301">{{ $t('导入') }}</button>
                <button type="button" class="normal_gray_btn" @click="add(1)" v-show="level === 0" v-permissions="26030301">{{ $t('添加设备类型') }}</button>
                <button type="button" class="normal_gray_btn" @click="add(2)" v-show="level === 1" v-permissions="26030301">{{ $t('添加设备系列') }}</button>
                <button type="button" class="normal_gray_btn" @click="add(3)" v-show="level === 2" v-permissions="26030301">{{ $t('添加设备型号') }}</button>
                <button type="button" class="normal_gray_btn ise-mr10" @click="setUse(1)" v-show="level == 3" v-permissions="26030301">{{ $t('启用') }}</button>
                <button type="button" class="normal_gray_btn" @click="setUse(0)" v-show="level == 3" v-permissions="26030301">{{ $t('禁用') }}</button>
              </div>
            </div>
            <div class="tree_box">
              <ise-tree :data="treeData" node-key="id" :props="treeOpt" ref="tree" :default-expanded-keys="creatId" @node-click="nodeClick" :render-content="renderContent" :expand-on-click-node="true"></ise-tree>
            </div>
          </div>
          <div class="right" v-show="editLevel > 0">
            <div class="breadcrumb">
              <span v-for="(item, index) in breadList" :key="index" :title="item">{{(item.length > 16 ? item.substring(0, 16) + '...' : item) + (index === breadList.length - 1 ? '' : ' > ')}}</span>
            </div>
            <div class="edit_box">
              <div class="edit_item">
                <span class="edit_label">{{$t('设备类型')}}</span>
                <div class="edit_input"><el-input  v-model.trim="lvInput.level1" :disabled="editLevel !== 1" maxlength="60"></el-input></div>
              </div>
              <div class="edit_item">
                <span class="edit_label">{{$t('设备系列')}}</span>
                <div class="edit_input"><el-input  v-model.trim="lvInput.level2" :disabled="editLevel !== 2" maxlength="60"></el-input></div>
              </div>
              <div class="edit_item">
                <span class="edit_label">{{$t('设备型号')}}</span>
                <div class="edit_input"><el-input  v-model.trim="lvInput.level3" :disabled="editLevel !== 3" maxlength="60"></el-input></div>
              </div>
            </div>
          </div>
          <div class="edit_btn_box" v-show="editLevel > 0">
            <button type="button" class="save_btn" @click="save" v-permissions="26030301">{{ $t('保存') }}</button>
          </div>
        </div>
      <input id="file" @change="changeFile($event)" v-show="false" type="file" accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet">
      <ise-dialog type="dialog-style3" width="550px" ok-text="导入" :visible.sync="importDialog" @ok="submitImport">
        <div slot="head">导入设备类型</div>
        <div slot="body">
          <div>
            <ise-label style="vertical-align: middle">导入文件</ise-label> <ise-input readonly v-model="uploadFile.file.name"></ise-input> <ise-button size="mini" @click="importExcel">选择文件</ise-button>     <el-button type="text" style="margin: 0 20px" @click="downloadTemplate">模版下载</el-button>
          </div>
        </div>
      </ise-dialog>
    </div>
</template>

<script>
    import Cookie from 'js-cookie'
    import { mapState } from 'vuex'
    export default {
        data () {
            return {
                list: [],
                pageInfo: {
                  total: 0
                },
                lvInput: {
                  level1: '',
                  level2: '',
                  level3: '',
                  level4: ''
                },
                treeOpt: {
                  label: 'mtModelName',
                  isLeaf: 'leaf',
                  children: 'children'
                },
                treeData: [{
                  level: 0,
                  id: 0,
                  mtModelName: this.$t('所有类型'),
                  children: []
                }],
                level: 0,
                breadList: [],
                breadcrumb: '',
                breadAll: [],
                editLevel: 0,
                creatTime: false, // 是否新建
                creatId: [0],
                uploadFile: {
                  file: ''
                },
                importDialog: false
            }
        },
        computed: {
          ...mapState({
            lang: state => state.common.lang
          })
        },
        watch: {
          lang () {
            let node = this.$refs.tree.getNode(0)
            node.data.mtModelName = this.$t('所有类型')
            node.loaded = false
            node.expand()
            this.nodeClick(node.data)
          }
        },
        mounted () {
          let lang = Cookie.get('isesol_lang')
          this.$store.commit('m:common/setLang', lang)
          this.getAll()
        },
        methods: {
            // 获取全部树结构
            getAll (node, update) {
              this.$store.dispatch('a:maintainProductionType/findAll').then(
                res => {
                  this.treeData[0].children = res.root
                  if (node) {
                    this.creatId = [node.data.id]
                  }
                  if (update) {
                    setTimeout(() =>{
                      let newNode = this.$refs.tree.getNode(this.breadAll[this.breadAll.length - 1].data.id)
                      this.breadList = []
                      this.breadAll = []
                      this.getTreeNode(newNode)
                    }, 500)
                  }
                },
                rej => {
                  this.$message.error(rej.errorInfo);
                }
              )
            },
            /* // 树结构懒加载
            loadNode (node, resolve) {
              if (node.level === 0) {
                return resolve([{
                  level: 0,
                  id: 0,
                  mtModelName: this.$t('所有类型')
                }]);
              } else {
                this.getTree(node, resolve)
              }
            },
            // 获取树节点内容
            getTree (node, resolve) {
              this.$store.dispatch('a:maintainProductionType/detail', {id: node.data.id}).then(
                res => {
                  if (node.level === 4) {
                    let list = []
                    for (let item of res) {
                      list.push({...item, leaf: true})
                    }
                    return resolve(list)
                  } else {
                    return resolve(res)
                  }
                },
                rej => {
                  this.$message.error(rej.errorInfo);
                }
              )
            }, */
            // 点击书节点,获取节点信息
            nodeClick (data) {
              this.creatTime = false
              this.level = data.level
              let tree = this.$refs.tree
              this.breadList = []
              this.breadAll = []
              this.getTreeNode(tree.getNode(data))
              for (let i = 1; i < 4; i++) {
                this.lvInput['level' + i] = this.breadList[i] ? this.breadList[i] + '' :  ''
              }
              this.editLevel = this.breadList.length - 1
            },
            getTreeNode(node){ //获取当前树节点和其父级节点
              if (node) {
                if (node.label !== undefined) {
                  this.breadList.unshift(node.label) //在数组头部添加元素
                  this.breadAll.unshift(node) //在数组头部添加元素
                  this.getTreeNode(node.parent) //递归
                  this.breadcrumb = this.breadList.join(' > ')
                }
              }
            },
            // 添加分类
            add (level) {
              this.creatTime = true
              this.editLevel = level
            },
            // 保存分类
            save () {
              let param, cmd
              if (!this.lvInput['level' + this.editLevel]) {
                this.$alert(this.$t('没有要保存的信息'), {
                    title: this.$t('提示'),
                    confirmButtonText: this.$t('确定')
                })
                return
              }
              if (this.creatTime) {
                param = {
                  mtModelName: this.lvInput['level' + this.editLevel],
                  parentId: this.breadAll[this.level].data.id
                }
                cmd = 'a:maintainProductionType/create'
              } else {
                param = {
                  mtModelName: this.lvInput['level' + this.editLevel],
                  id: this.breadAll[this.level].data.id
                }
                cmd = 'a:maintainProductionType/update'
              }
              this.$store.dispatch(cmd, param).then(
                res => {
                  if (this.creatTime) {
                    let node = this.$refs.tree.getNode(this.breadAll[this.breadAll.length - 1].data.id)
                    this.getAll(node)
                    this.lvInput['level' + this.editLevel] = ''
                    this.editLevel--
                    this.creatTime = false
                  } else {
                    let node = this.$refs.tree.getNode(this.breadAll[this.breadAll.length - 1].data.id)
                    this.getAll(node, true)
                  }
                  this.$message.success(this.$t('保存成功') + '！');
                },
                rej => {
                  this.$message.error(rej.errorInfo);
                }
              )
            },
            // 启用禁用控制
            setUse (isInUse) {
              let param = {
                isInUse,
                id: this.breadAll[this.level].data.id
              }
              let cmd = 'a:maintainProductionType/update'
              this.$store.dispatch(cmd, param).then(
                () => {
                  let node = this.$refs.tree.getNode(this.breadAll[this.breadAll.length - 1].data.id)
                  this.getAll(node)
                  let notice = isInUse ? this.$t('启用成功') : this.$t('禁用成功')
                  this.$message.success(notice);
                },
                rej => {
                  this.$message.error(rej.errorInfo);
                }
              )
            },
            // 启用禁用渲染
            renderContent (h, {node, data}) {
              if (data.level === 3 && !data.isInUse) {
                return(
                  <span class="custom-tree-node">
                    <span class="isRed">{node.label}</span>
                  </span>);
              } else {
                return(<span class="custom-tree-node" title={node.label}>{node.label}</span>);
              }
            },
            importExcel () {
              document.getElementById('file').value = ''
              document.getElementById('file').click()
            },
            changeFile (el) {
              this.uploadFile.file = el.target.files[0]
            },
            submitImport () {
              if (!this.uploadFile.file) {
                this.$message.warning('请选择需要导入的文件！')
                return
              }
              this.$loading({
                lock: true,
                text: this.$t('正在导入') + '...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              });
              this.$store.dispatch('a:common/uploadFile', this.uploadFile).then(
                  res => {
                    this.$store.dispatch('a:maintainProductionType/importMtModel', { url: res.url }).then(res => {
                      if (res && res.detail && res.detail.length === 0) {
                        this.$message.success('导入成功！')
                        this.getAll(null, true)
                        this.importDialog = false
                      } else {
                        let message = ''
                        for (let i of res.detail) {
                          message += '第' + i.lineNumber + '行' + i.errorInfo + ''
                        }
                        this.$message.error(message)
                      }

                    }).finally(() => {
                      this.$loading().close()
                    })
                  },
                  rej => {
                    this.$loading().close()
                    this.$message.error(rej.errorInfo || '导入失败');
                  }
              )
          },
          downloadTemplate () {
            const newWindow = window.open('', '_blank')
            newWindow.location.href = window.location.origin + '/设备类型导入模版.xlsx'
          }
        }
    }
</script>

<style>
  .ise-tree .el-tree-node__label{
    font-size: 12px;
  }
  .custom-tree-node{
    font-size: 12px;
    display: inline-block;
    width:200px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
  }
  .isRed{
    color: red
  }
</style>

<style lang="scss" scoped>
.content{
  width: 100%;
  border-top: 2px solid #fabf40;
  margin-top: 1px;
  overflow: hidden;
}
.left{
  box-sizing: border-box;
  width: 340px;
  height: 331px;
  max-height: 331px;
  overflow: hidden;
  background-color: #FFFFFF;
  float: left;
  border-bottom: 1px solid #F1F2F6;
  margin-left: 20px;
}
.right{
  width: 900px;
  height: 330px;
  overflow: hidden;
  border-bottom: 1px solid #F1F2F5;
  float: right;
}
.tree_opt{
  width: 100%;
  height: 40px;
  border-bottom: 1px solid #F1F2F5;
  text-align: center;
  padding-top: 6px;
  .import-file{
    display: inline-block;
  }
}
.tree_box{
  width: 300px;
  padding: 0 20px;
  height: 290px;
  overflow-x: hidden;
  overflow-y: auto;
}
.breadcrumb{
  height: 38px;
  line-height: 22px;
  background-color: #EFF3F6;
  overflow: hidden;
  padding: 8px 25px;
  box-sizing: border-box;
  margin-top: 1px;
  margin-bottom: 1px;
  width: 100%;
  font-size: 12px;
  font-weight: normal;
}
.edit_box{
  width: 100%;
  height: 290px;
  border-top: 1px solid #FEECC6;
  overflow: hidden;
}
.edit_item{
  width: 42%;
  height: 30px;
  padding-left: 8%;
  padding-top: 30px;
}
.edit_label{
  font-size: 12px;
  line-height: 24px;
  display: inline-block;
  margin-right: 10px;
}
.edit_input{
  width: 200px;
  display: inline-block;
}
.ctrl-box{
  width: 100%;
}
</style>
